import { Widget } from '../../../widget/widget';
import {
  DebateSeasonsWidgetComponent,
  DebateVotesWidgetComponent,
  DebateOpinionsWidgetComponent,
  DebateActionsWidgetComponent
} from '../../../widget/widgets';

export const DebateSeasonsWidget = (debateId, debateData) => {
  return new Widget(DebateSeasonsWidgetComponent, {
    id: `widget-seasons-'${debateId}'`,
    name: `widget-seasons-'${debateId}'`,
    debateData
  });
};

export const DebateVotesWidget = (debateId, debateData) => {
  return new Widget(DebateVotesWidgetComponent, {
    id: `widget-votes-'${debateId}'`,
    name: `widget-votes-'${debateId}'`,
    debateData
  });
};

export const DebateOpinionsWidget = (debateId, debateData) => {
  return new Widget(DebateOpinionsWidgetComponent, {
    id: `widget-opinions-'${debateId}'`,
    name: `widget-opinions-'${debateId}'`,
    debateData
  });
};

export const DebateActionsWidget = (debateId, debateData) => {
  return new Widget(DebateActionsWidgetComponent, {
    id: `widget-actions-'${debateId}'`,
    name: `widget-actions-'${debateId}'`,
    debateId,
    debateData
  });
};
